import React from 'react';
import styled from 'styled-components';
import {Card} from "@blueprintjs/core";
import {useHistory, useLocation} from "react-router";


const HEADER_HEIGHT = 60


const HeaderDiv = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;

  height: ${HEADER_HEIGHT}px;
  background-color: #0C98E9;
  color: white;
  
  box-shadow: 0 2px 8px 2px rgb(0, 0, 0, 0.15);
  
  @media print {
    display: none;
  }
`

export const Header = ({children}) => {
  return (
    <HeaderDiv>
      {children}
    </HeaderDiv>
  )
}

const Logo = () => {

  const history = useHistory()
  const location = useLocation()

  return (
    <img
      src={'https://resources.ghvbl.com/ghvbl-logo.png'}
      alt={'GHVBL Logo'}
      width={`${HEADER_HEIGHT - 10}px`}
      height={`${HEADER_HEIGHT - 10}px`}
      style={{margin: '5px 10px', cursor: 'pointer'}}
      onClick={() => {
        history.push({...location, pathname: '/home'})
      }}
    />
  )
}

const ThirdSection = styled.div`
  width: 33%;
`

const SiteName = () => {
  let title = 'GHVBL'

  return <h1
    style={{
      lineHeight: `${HEADER_HEIGHT*0.4}px`,
      textAlign: 'center',
      fontWeight: '400'}}>
    {title}
  </h1>
}

export const DefaultHeaderContent = () => {
  return (
    <div style={{display: 'flex', justifyContent: 'space-between'}}>
      <ThirdSection>
        <Logo />
      </ThirdSection>

      <ThirdSection>
        <SiteName />
      </ThirdSection>

      <ThirdSection>

      </ThirdSection>
    </div>
  )
}

const ContentBlock = styled.div`
  background-color: white;
  width: 100%;
  border-radius: 6px;
  box-shadow: 0 1px 4px 1px rgb(0, 0, 0, 0.15);
  padding: 10px;
  margin: 20px 0;
`

const PageStyles = styled.div`
  padding: 10px;
  
  @page {
    size: portrait;
  }
`

const MainContentStyles = styled.div`
  width: 100%;

  padding-top: ${HEADER_HEIGHT}px;
  
  display: flex;
  justify-content: center;
`

const MobilePage = ({ headerContent, titleContent, footerContent, wrapContentInCards = true, maxWidth = 900, usePaddingInTitle = true, children }) => {

  return (
    <PageStyles>
      <Header>
        {headerContent ?? <DefaultHeaderContent />}
      </Header>

      <MainContentStyles>
        <div style={{width: '100%', maxWidth: maxWidth + 'px'}}>
          {titleContent &&
            <Card style={{padding: usePaddingInTitle ? undefined : 0}}>
              {titleContent}
            </Card>
          }

          {wrapContentInCards ? (
            <ContentBlock>
              {children}
            </ContentBlock>
            ):(
              <>
                {children}
              </>
          )}

          {footerContent &&
            <div>
              {footerContent}
            </div>
          }
        </div>
      </MainContentStyles>
    </PageStyles>
  )
}

export default MobilePage
